import { MenuProps } from 'antd'
import { Icon } from 'shared/iconpack'

import { palette } from 'shared/config/styles/palette'

export const items: MenuProps['items'] = [
  {
    label: <span className="text-red_2 leading-[20px] text-[14px]">Выйти</span>,
    key: 'logout',
    icon: (
      <Icon
        name="exit"
        color={palette.red_2}
        size={20}
      />
    ),
  },
]
